import React from 'react';

import {Colors, Text} from '@optimaxdev/design-system';

import {CloudinaryImage} from 'components/cloudinaryImage/cloudinaryImage';
import {OrderDetailsItemsType} from 'types/orderDetailsTypes';

import s from './accessoriesItem.scss';

type PropsType = {
    item: OrderDetailsItemsType;
};

/**
 * Accessories item for CL TYP
 */
export const AccessoriesItem = ({item}: PropsType) => {
    return (
        <div className={s.header}>
            <div className={s.imageWrapper}>
                <CloudinaryImage
                    alt={item.name}
                    className={s.img}
                    src={item.product.image}
                    width="100%"
                />
            </div>
            <Text
                as="p"
                color={Colors.blueCharcoal}
                lineHeight="24px"
                margin="0 0 6px"
                size="16px"
                bold
            >
                {item.windowName}
            </Text>
        </div>
    );
};
